<div [formGroup]="formGroup">
    <div formArrayName="dosages">
        @for (dosage of dosages.controls; track dosage; let i = $index) {
        <div [formGroupName]="i">
            <mat-label class="font-weight-500">{{ (i + 1) + '. '+ ('medicalHistory.modify.dosisModal.dosisValues.title'
                | translate) }} </mat-label>
            <div class="flex-v-center gap-5 padding-top-10">
                @if (showApplicationType && i === 0) {
                <mat-form-field appearance="outline" class="mat-form-field width-150"
                    [id]="'somApplicationType'+ idHtmlElements + i">
                    <mat-label>{{
                        "medicalHistory.modify.dosisModal.dosisValues.dropdown.administrationMode.label" | translate
                        }}</mat-label>
                    <mat-select formControlName="applicationType" (selectionChange)="amountUpdated()">
                        @for (applicationType of applicationTypes; track applicationType) {
                        <mat-option [value]="applicationType" [id]="'spn' + applicationType.id">
                            <div>
                                @switch (currentLanguage) {
                                @case (Languages.de) {
                                <span>
                                    {{ applicationType.designationDE }}
                                </span>
                                }
                                @case (Languages.it) {
                                <span>
                                    {{ applicationType.designationIT }}
                                </span>
                                }
                                @case (Languages.fr) {
                                <span>
                                    {{ applicationType.designationFR }}
                                </span>
                                }
                                }
                            </div>
                        </mat-option>
                        }

                    </mat-select>
                </mat-form-field>
                }

                <mat-form-field appearance="outline" class="mat-form-field width-dropdown-serving-mode "
                    [id]="'somServingMode'+ idHtmlElements + i"
                    [class.margin-left-without-application-type]="showApplicationType && showApplicationType && i > 0">
                    <mat-label>{{
                        "medicalHistory.modify.dosisModal.dosisValues.dropdown.administrationMode.label" | translate
                        }}</mat-label>
                    <mat-select formControlName="servingMode" (selectionChange)="amountUpdated()">
                        @for (servingMode of servingModes; track servingMode) {
                        <mat-option [value]="servingMode" [id]="'spn'+ servingMode.id">
                            <div>
                                @switch (currentLanguage) {
                                @case (Languages.de) {
                                <span>
                                    {{ servingMode.designationDE }}
                                </span>
                                }
                                @case (Languages.it) {
                                <span>
                                    {{ servingMode.designationIT }}
                                </span>
                                }
                                @case (Languages.fr) {
                                <span>
                                    {{ servingMode.designationFR }}
                                </span>
                                }
                                }
                            </div>
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="width-100">
                    <mat-label>
                        {{ "medicalHistory.modify.dosisModal.dosisValues.input.amount.label" | translate }}
                    </mat-label>
                    <input dianaNumberInputCheck [allowNegative]="false" matInput formControlName="amount"
                        [totalDecimalCases]="4" [id]="'intDosisAmount'+ idHtmlElements + i">
                </mat-form-field>
                <mat-form-field appearance="outline" class="width-100">
                    <mat-label>
                        {{ "medicalHistory.modify.dosisModal.dosisValues.input.unit.label" | translate }}
                    </mat-label>
                    <input matInput formControlName="units" [id]="'intSingleFarmUnits' + idHtmlElements + i">
                </mat-form-field>
                <mat-form-field appearance="outline" class="width-150">
                    <mat-label>
                        {{ "medicalHistory.modify.dosisModal.dosisValues.input.durationInDays.label" | translate }}
                    </mat-label>
                    <input dianaNumberInputCheck [allowNegative]="false" [totalDecimalCases]="0" matInput
                        [id]="'intDurationInDays'+ idHtmlElements + i" formControlName="durationInDays">
                </mat-form-field>
                @if (dosages.controls.length === 2 && (!treatmentInstruction || treatmentInstruction.secondServingModeId
                === undefined ? true: false) && formGroup.enabled) {
                <div class="width-delete-button">
                    @if (i > 0) {
                    <button mat-icon-button class="icon-active" (click)="removeDosis()">
                        <mat-icon>delete</mat-icon>
                    </button>
                    }
                </div>
                }

            </div>
            @if (dosages.controls.length === 1 && formGroup.enabled) {
            <button color="primary" [id]="'btnAddDosis' + i" mat-raised-button (click)="addDosagesDetails()">{{(i + 2) +
                '.
                '}}{{'medicalHistory.modify.dosisModal.dosisValues.button.addDosage.label' | translate}}</button>
            }
        </div>
        }

    </div>
    <mat-divider class="divider-margins"></mat-divider>
    <mat-label class="font-weight-500">{{
        "medicalHistory.modify.dosisModal.weaningPeriods.label" | translate
        }}</mat-label>
    <div class="d-flex gap-5 padding-top-10">
        <div class="d-flex flex-column">
            <mat-form-field appearance="outline" class="width-150">
                <mat-label>
                    {{ "medicalHistory.modify.dosisModal.input.milkWithdrawalPeriod.label" | translate }}
                </mat-label>
                <input dianaNumberInputCheck [allowNegative]="false" [id]="'intMilkWithdrawalPeriod' + idHtmlElements"
                    [totalDecimalCases]="0" matInput formControlName="milkWithdrawalPeriod">
            </mat-form-field>
            @if (treatmentInstruction && compareMinValue(milkWithdrawalPeriodControl, treatmentInstruction.minMilkWithdrawalPeriod)) {
            <div class="info-color">
                *{{'general.error.min' | translate}} {{treatmentInstruction.minMilkWithdrawalPeriod}}
            </div>
            }
        </div>
        <div class="d-flex flex-column">
            <mat-form-field appearance="outline" class="width-150">
                <mat-label>
                    {{ "medicalHistory.modify.dosisModal.input.meatWithdrawalPeriod.label" | translate }}
                </mat-label>
                <input dianaNumberInputCheck [allowNegative]="false" [id]="'intMeatWithdrawalPeriod' + idHtmlElements"
                    [totalDecimalCases]="0" matInput formControlName="meatWithdrawalPeriod">
            </mat-form-field>
            @if (treatmentInstruction && compareMinValue(meatWithdrawalPeriodControl, treatmentInstruction.minMeatWithdrawalPeriod)) {
            <div class="info-color">
                *{{'general.error.min' | translate}} {{treatmentInstruction.minMeatWithdrawalPeriod}}
            </div>
            }
        </div>
        <div class="d-flex flex-column">
            <mat-form-field appearance="outline" class="width-150">
                <mat-label>
                    {{ "medicalHistory.modify.dosisModal.input.organWithdrawalPeriod.label" | translate }}
                </mat-label>
                <input dianaNumberInputCheck [allowNegative]="false" [totalDecimalCases]="0" matInput
                    formControlName="organWithdrawalPeriod" [id]="'intOrganWithdrawalPeriod' + idHtmlElements">
            </mat-form-field>
            @if (treatmentInstruction && compareMinValue(organWithdrawalPeriodControl, treatmentInstruction.minOrganWithdrawalPeriod)) {
            <div class="info-color">
                *{{'general.error.min' | translate}} {{treatmentInstruction.minOrganWithdrawalPeriod}}
            </div>
            }
        </div>
        <div class="d-flex flex-column">
            <mat-form-field appearance="outline" class="width-150">
                <mat-label>
                    {{ "medicalHistory.modify.dosisModal.input.injectionPointWithdrawalPeriod.label" | translate }}
                </mat-label>
                <input dianaNumberInputCheck [allowNegative]="false" [totalDecimalCases]="0" matInput
                    formControlName="injectionPointWithdrawalPeriod"
                    [id]="'intInjectionPointWithdrawalPeriod' + idHtmlElements">
            </mat-form-field>
            @if (treatmentInstruction && compareMinValue(injectionPointWithdrawalPeriodControl,
            treatmentInstruction.minInjectionPointWithdrawalPeriod)) {
            <div class="info-color">
                *{{'general.error.min' | translate}} {{treatmentInstruction.minInjectionPointWithdrawalPeriod}}
            </div>
            }
        </div>

    </div>
</div>
